import { RootState } from "@store";
import { IAuthorization } from "@store/auth/actionTypes";
import { useSelector } from "react-redux";

export const useAuth = (): IAuthorization => {
  const auth = useSelector((state: RootState) => state.auth as IAuthorization);
  return auth;
};
